import { Controller } from 'react-hook-form';
import {
  Autocomplete,
  InputText,
  Textarea,
  Checkbox,
  InputSize,
  SelectSize,
  DateInput,
  DateInputSize,
  AutocompleteMultiple,
  Select,
} from '@ui/src';
import { CorporateOverviewGeneral } from '../../../hoc/corporate/types';
import { OverviewGeneralRowTypes } from '../types';

import cn from './overview.module.css';

const OverviewGeneralRow = ({
  title,
  description,
  children,
  edit,
  control,
  type,
  list,
  name,
  checkboxTitle,
  error,
  selectType,
  defaultValue,
  zIndex = 10,
}: OverviewGeneralRowTypes) => {
  let content;

  if (edit) {
    if (type === 'text') {
      content = (
        <div className={cn.overviewRow}>
          <Controller
            control={control}
            name={name as keyof CorporateOverviewGeneral}
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <InputText
                name={name as string}
                placeholder=""
                className={cn.textInput}
                onChange={onChange}
                value={value as string}
                size={InputSize.SMALL}
                error={error}
              />
            )}
          />
        </div>
      );
    }

    if (type === 'date') {
      content = (
        <div className={cn.overviewRow}>
          <Controller
            control={control}
            name={name as keyof CorporateOverviewGeneral}
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <DateInput
                value={value as string}
                onChange={(date) => onChange(new Date(date).toISOString())}
                className={cn.dateOfBirthInput}
                size={DateInputSize.SMALL}
                error={error}
              />
            )}
          />
        </div>
      );
    }

    if (type === 'textarea') {
      content = (
        <div className={cn.overviewRow}>
          <Controller
            control={control}
            name={name as keyof CorporateOverviewGeneral}
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Textarea
                name={name as string}
                placeholder=""
                className={cn.textInput}
                onChange={onChange}
                value={value as string}
                error={error}
              />
            )}
          />
        </div>
      );
    }

    if (type === 'checkbox') {
      content = (
        <div className={cn.overviewRow}>
          <Controller
            control={control}
            name={name as keyof CorporateOverviewGeneral}
            render={({ field: { onChange, value } }) => (
              <Checkbox
                type="checkbox"
                name={name as string}
                checked={value as boolean}
                title={checkboxTitle as string}
                onChange={(e) => onChange(e.target.checked)}
              />
            )}
          />
        </div>
      );
    }

    if (type === 'select' && list?.length) {
      content = (
        <div className={cn.overviewRow} style={{ zIndex }}>
          <Controller
            control={control}
            name={name as keyof CorporateOverviewGeneral}
            defaultValue={defaultValue}
            render={({ field: { onChange, value } }) => (
              <Select
                list={list}
                placeholder="Choose value"
                name={name}
                selectWrapperClassName={cn.overviewSelectWrapper}
                value={(value as string) || defaultValue}
                onChange={onChange}
                size={SelectSize.SMALL}
                mode={selectType}
                error={error}
              />
            )}
          />
        </div>
      );
    }

    if (type === 'autocomplete' && list?.length) {
      content = (
        <div className={cn.overviewRow} style={{ zIndex }}>
          <Controller
            control={control}
            name={name as keyof CorporateOverviewGeneral}
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                list={list}
                placeholder="Choose value"
                name={name}
                value={value as string}
                className={`${cn.infoRowAutocomplete} ${cn.overviewAutocompleteWrapper}`}
                onChange={onChange}
                size={SelectSize.SMALL}
                error={error}
              />
            )}
          />
        </div>
      );
    }

    if (type === 'autocomplete-multiple' && list?.length) {
      content = (
        <div className={cn.overviewRow}>
          <Controller
            control={control}
            name={name as keyof CorporateOverviewGeneral}
            render={({ field: { onChange, value } }) => (
              <AutocompleteMultiple
                list={list}
                placeholder="Choose value"
                name={name}
                value={value as string}
                className={`${cn.infoRowAutocomplete} ${cn.overviewAutocompleteWrapper}`}
                onChange={onChange}
                size={SelectSize.SMALL}
                error={error}
              />
            )}
          />
        </div>
      );
    }
  } else if (defaultValue) {
    content = <div className={cn.generalRowDescription}>{defaultValue}</div>;
  } else {
    content = (
      <div className={cn.generalRowDescription}>
        {description}
        {children}
      </div>
    );
  }

  return (
    <div className={cn.generalRow}>
      <div className={cn.generalRowTitle}>{title}</div>
      {content}
    </div>
  );
};

export default OverviewGeneralRow;
